import Drawer from "@mui/material/Drawer";
import Stack from "@mui/material/Stack";

import { useDispatch, useSelector } from "@src/store";
import {
  VivIdeasAction,
  VivIdeasSelector,
} from "@src/store/slices/experienceBuilder/ideas";

import { IdeaLibraryResults } from "./IdeaLibraryResults";
import { IdeaLibrarySidebar } from "./IdeaLibrarySidebar";

/**
 * Full-panel "Browse more ideas" library that slides in from the right over the
 * chat, as a right-anchored Drawer. Reads everything from redux and sends via
 * the `sendIdea` thunk rather than the panel context. Layout/typography match
 * the Figma (220px sidebar + flexible list; note the theme's spacing unit is
 * 4px).
 */
export const VivIdeaLibrary = () => {
  const dispatch = useDispatch();
  const open = useSelector(VivIdeasSelector.isLibraryOpen);

  return (
    <Drawer
      anchor="right"
      open={open}
      sx={{ zIndex: 2000 }}
      slotProps={{
        backdrop: { sx: { backgroundColor: "rgba(0, 0, 0, 0.05)" } },
      }}
      onClose={() => dispatch(VivIdeasAction.closeLibrary())}
    >
      <Stack direction="row" sx={{ width: 550, height: "100%" }}>
        <IdeaLibrarySidebar />
        <IdeaLibraryResults />
      </Stack>
    </Drawer>
  );
};
